import { matchPath, useLocation, useParams } from 'react-router-dom';

const useCampaignPage = () => {
    const { positionId, campaignId: employerCampaignId } = useParams();
    const location = useLocation();

    const isCreateMode = location.pathname.endsWith('create');
    const isJobCampaignPage = Boolean(positionId);
    const isEmployerCampaignPage = Boolean(employerCampaignId);
    const isSystemCampaignEditPage = !!matchPath(location.pathname, {
        path: '*/employer/:employerId/system/campaign/:campaignId',
        exact: false,
        strict: false,
    });

    return {
        isSystemCampaignEditPage,
        isJobCampaignPage,
        isEmployerCampaignPage,
        isCreateMode,
    };
};

export {
    useCampaignPage,
};
